'use client'

import { motion, useReducedMotion } from 'motion/react'
import type { HTMLMotionProps } from 'motion/react'

import type { WithAsChild } from '@/components/animate-ui/primitives/animate/slot'
import { Slot } from '@/components/animate-ui/primitives/animate/slot'

type ButtonProps = WithAsChild<
  HTMLMotionProps<'button'> & {
    hoverScale?: number
    tapScale?: number
  }
>

function Button({
  hoverScale = 1.05,
  tapScale = 0.95,
  asChild = false,
  ...props
}: ButtonProps) {
  const Component = asChild ? Slot : motion.button
  // `whileHover`/`whileTap` are NOT automatically disabled for
  // `prefers-reduced-motion` — Motion only does that under a `MotionConfig
  // reducedMotion="user"` ancestor, and this app doesn't set one up
  // globally. Check directly here so every consumer of this primitive gets
  // the reduced-motion fallback for free.
  const prefersReducedMotion = useReducedMotion()

  return (
    <Component
      whileTap={prefersReducedMotion ? undefined : { scale: tapScale }}
      whileHover={prefersReducedMotion ? undefined : { scale: hoverScale }}
      {...props}
    />
  )
}

export { Button, type ButtonProps }
